module.exports = __webpack_public_path__ + "img/18.0785e304.jpg";